import http from '../request.js'

export default {
  list: (data) => {
    return http({
      url: '/api/integral_product/list',
      data
    })
  },

  get: (data) => {
    return http({
      url: '/api/integral_product/get',
      data
    })
  },

  add: (data) => {
    return http({
      url: '/api/integral_product/save',
      data
    })
  },

  delete: (data) => {
    return http({
      url: '/api/integral_product/delete',
      data
    })
  },

  userIntegral: (data) => {
    return http({
      url: '/api/user/integral_list',
      data
    })
  },

  addSpec: (data) => {
    return http({
      url: '/api/integral_product_spec/save',
      data
    })
  },

  specList: (data) => {
    return http({
      url: '/api/integral_product_spec/list',
      data
    })
  },

  specDelete: (data) => {
    return http({
      url: '/api/integral_product_spec/delete',
      data
    })
  }
}
